import { useRef, useState } from "react";
import { ApiError } from "./api.ts";
import { refreshPhotos, squarePhoto, usePhoto } from "./photos.ts";
import { Avatar, Icon } from "./ui.tsx";

/* A person's picture with Add, Change and Remove. On a phone, choosing a file
 * offers the camera or the photo library. The picture is cropped to a square
 * and shrunk before it leaves the device. */
export function PhotoEdit({ id, name, size = 64, onSave, onRemove }: {
  id: string; name: string; size?: number;
  onSave: (dataUrl: string) => Promise<unknown>; onRemove: () => Promise<unknown>;
}) {
  const has = !!usePhoto(id);
  const input = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const run = async (fn: () => Promise<unknown>) => {
    setBusy(true); setError(null);
    try { await fn(); await refreshPhotos(); }
    catch (e) { setError(e instanceof ApiError ? e.message : "That picture could not be used. Try another."); }
    finally { setBusy(false); }
  };
  return (
    <div className="photo-edit">
      <button type="button" className="photo-btn" disabled={busy} onClick={() => input.current?.click()}
        aria-label={has ? `Change photo of ${name}` : `Add a photo of ${name}`}>
        <Avatar id={id} name={name} size={size} fontSize={size * 0.42} />
        <span className="cam" aria-hidden="true"><Icon name="camera" size={14} sw={2.2} /></span>
      </button>
      <div className="photo-acts">
        <button type="button" className="linkish" disabled={busy} onClick={() => input.current?.click()}>{busy ? "Saving…" : has ? "Change photo" : "Add photo"}</button>
        {has && <button type="button" className="linkish danger" disabled={busy} onClick={() => void run(onRemove)}>Remove</button>}
        {error && <span className="ferr" role="alert">{error}</span>}
      </div>
      <input ref={input} type="file" accept="image/*" hidden
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) void run(async () => onSave(await squarePhoto(f))); }} />
    </div>
  );
}
